// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionTemplate_container__jjKD1","list":"SubscriptionTemplate_list__uNd3i","sectionTitle":"SubscriptionTemplate_sectionTitle__bT8VW"};